// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// // Import local banner images
// import banner1 from "./Cloudimages/cocking.png";
// import banner2 from "./Cloudimages/restur.jpg";
// import banner3 from "./Cloudimages/franchiesgirl.jpg";
// import banner4 from "./Cloudimages/booking.webp";

// const BannerSlider = () => {
//   const banners = [banner1, banner2, banner3, banner4];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 1, // One banner at a time
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     cssEase: "ease-in-out",
//     arrows: false,
//   };

//   return (
//     <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "-50px", }}>
//       <div className="sliderWrapper">
//         <Slider {...settings}>
//           {banners.map((src, index) => (
//             <div key={index} style={styles.slideItem}>
//               <div style={styles.imageContainer}>
//                 <img src={src} alt={`banner-${index}`} style={styles.image} />
//                 <div style={styles.overlay}>
//                   <h2 style={styles.overlayText}>Welcome to Maamaas</h2>
//                   <p style={styles.overlaySubText}>Experience gourmet flavors and crafted beverages.</p>

//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>

//         <style>
//           {`
//             .sliderWrapper {
//               width: 63vw!important;
//               max-width: 100%;
//               margin: 0 auto;
//             }

//             /* Banner heights */
//             .sliderWrapper img {
//               height: 400px;
//               object-fit: cover;
//               border-radius: 12px;
//               transition: transform 0.5s ease;
//             }

//             /* Fade-in animation */
//             .sliderWrapper .overlay {
//               animation: fadeInUp 1s ease forwards;
//             }

//             @keyframes fadeInUp {
//               0% { opacity: 0; transform: translateY(20px); }
//               100% { opacity: 1; transform: translateY(0); }
//             }

//             /* Responsive widths */
//             @media (max-width: 768px) {
//               .sliderWrapper { width: 721px; }
//               .sliderWrapper img { height: 300px; }
//             }
//             @media (max-width: 425px) {
//               .sliderWrapper { width: 392px; }
//               .sliderWrapper img { height: 250px; }
//             }
//             @media (max-width: 375px) {
//               .sliderWrapper { width: 334px; }
//               .sliderWrapper img { height: 220px; }
//             }
//             @media (max-width: 320px) {
//               .sliderWrapper { width: 282px; }
//               .sliderWrapper img { height: 180px; }
//             }

//             /* Overlay text adjustments */
//             .sliderWrapper .overlay h2 { font-size: 28px; font-weight: bold; text-align: center; }
//             .sliderWrapper .overlay p { font-size: 16px; text-align: center; }

//             @media (max-width: 425px) {
//               .sliderWrapper .overlay h2 { font-size: 22px; }
//               .sliderWrapper .overlay p { font-size: 14px; }
//             }
//             @media (max-width: 375px) {
//               .sliderWrapper .overlay h2 { font-size: 20px; }
//               .sliderWrapper .overlay p { font-size: 12px; }
//             }
//             @media (max-width: 320px) {
//               .sliderWrapper .overlay h2 { font-size: 18px; }
//               .sliderWrapper .overlay p { font-size: 11px; }
//             }
//           `}
//         </style>
//       </div>
//     </div>
//   );
// };

// export default BannerSlider;

// // Inline styles for overlay positioning
// const styles = {
//   slideItem: {
//     position: "relative",
//   },
//   imageContainer: {
//     position: "relative",
//     overflow: "hidden",
//     borderRadius: 12,
//   },
//   image: {
//     width: "100%",
//   },
//   overlay: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     textAlign: "center",
//     color: "#fff",
//     backgroundColor: "rgba(0,0,0,0.3)",
//     padding: "15px 20px",
//     borderRadius: 10,
//   },
//   overlayText: {
//     margin: 0,
//   },
//   overlaySubText: {
//     margin: 0,
//   },
// };




import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    arrows: false,
  };

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          "https://backend.maamaas.com/food/api/admin-banner/all",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data;

        if (!Array.isArray(data) || data.length === 0) return;

        const formattedBanners = data.flatMap((bannerObj) => {
          const images = [
            bannerObj.banner,
            bannerObj.image1,
            bannerObj.image2,
            bannerObj.image3,
            bannerObj.image4,
          ];

          return images
            .filter((img) => img)
            .map((img, index) => ({
              id: `${bannerObj.id}-${index}`,
              src: img,
              title: bannerObj.companyName || "Welcome to Maamaas",
              desc:
                bannerObj.description ||
                "Experience gourmet flavors and crafted beverages.",
            }));
        });

        setBanners(formattedBanners);
      } catch (error) {
        console.error("Error fetching banner images:", error);
       
      }
    };

    fetchBanners();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        marginTop: "-50px",
      }}
    >
      <div className="sliderWrapper">
        <Slider {...settings}>
          {banners.map((banner, index) => (
            <div key={banner.id || index} style={styles.slideItem}>
              <div style={styles.imageContainer}>
                <img src={banner.src} alt="banner" style={styles.image} />

                <div style={styles.overlay}>
                  <h2 style={styles.overlayText}>{banner.title}</h2>
                  <p style={styles.overlaySubText}>{banner.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <style>
          {`
            .sliderWrapper {
              width: 63vw!important;
              max-width: 100%;
              margin: 0 auto;
            }

            .sliderWrapper img {
              height: 400px;
              object-fit: cover;
              border-radius: 12px;
              transition: transform 0.5s ease;
            }

            .sliderWrapper .overlay {
              animation: fadeInUp 1s ease forwards;
            }

            @keyframes fadeInUp {
              0% { opacity: 0; transform: translateY(20px); }
              100% { opacity: 1; transform: translateY(0); }
            }

            @media (max-width: 768px) {
              .sliderWrapper { width: 721px; }
              .sliderWrapper img { height: 300px; }
            }
            @media (max-width: 425px) {
              .sliderWrapper { width: 392px; }
              .sliderWrapper img { height: 250px; }
            }
            @media (max-width: 375px) {
              .sliderWrapper { width: 334px; }
              .sliderWrapper img { height: 220px; }
            }
            @media (max-width: 320px) {
              .sliderWrapper { width: 282px; }
              .sliderWrapper img { height: 180px; }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default BannerSlider;

const styles = {
  slideItem: { position: "relative" },

  imageContainer: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 12,
  },

  image: {
    width: "100%",
  },

  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.3)",
    padding: "15px 20px",
    borderRadius: 10,
  },

  overlayText: { margin: 0 },
  overlaySubText: { margin: 0 },
};
